// Automatically generated from TW.Saga.Core.Base, Version=1.0.0.0, Culture=neutral, PublicKeyToken=null @30.07.2019 13:39:27
import { ProcedureActionCondition_abstract } from './../abstract/SagaActionLib/ProcedureActionCondition_abstract';
export class ProcedureActionCondition extends ProcedureActionCondition_abstract {}
